import React from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {convertToString} from "../../util/functions";
import {isEmpty} from "../../util/is";
import {Controller} from "react-hook-form";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";

const RadioButtonForm = ({identificador ,label, defaultValue, options, className = "classDefaultRadioB", handleChange, value, width = `100%`, disabled, required = false, inputProps = {}, customError = null, flexAround = false}) => {

    return(
        <FormControl  key={`key${identificador}`}  component="fieldset" className={`my-1 ${className}`}>
          <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
            <InputLabel shrink htmlFor={identificador} style={{width, fontWeight: 'bold', textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", pointerEvents: "auto"}}>{`${required ? `*${label}` : `${label}`}`}</InputLabel>
          </Tooltip>
            {  !('control' in inputProps) ?
                <RadioGroup row aria-label={identificador} value={convertToString(value)}
                            onChange={({target:{name, value}}) => handleChange({name, value})}
                            className={`radioGroupForm mw-100 ${flexAround ? 'justify-content-around' : ''}`}
                            name={identificador} defaultValue={convertToString(defaultValue)} style={{width}}>
                    {
                        options &&
                        options.map((item, index) => (
                            <FormControlLabel key={index} value={convertToString(item.value)} control={<Radio inputProps={inputProps} disabled={disabled} color="primary" />} label={item.text} />
                        ))
                    }
                </RadioGroup>
                :
                <Controller
                    rules={{ required: required }}
                    control={inputProps.control}
                    defaultValue={convertToString(defaultValue)}
                    name={identificador}
                    render={({ field: { onChange, onBlur, value } }) =>
                        (<RadioGroup row
                                     aria-label={identificador}
                                     defaultValue={convertToString(defaultValue)}
                                     value={convertToString(value)}
                                     onChange={onChange}
                                     onBlur={onBlur}
                                     className={`radioGroupForm mw-100 ${flexAround ? 'justify-content-around' : ''}`}
                                     name={identificador}
                                     style={{width}}>
                            {
                                options &&
                                options.map((item, index) => (
                                    <FormControlLabel key={index} value={convertToString(item.value)} control={<Radio disabled={disabled} color="primary" />} label={item.text} />
                                ))
                            }
                        </RadioGroup>)
                    }
                />
            }
            {
              (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }
        </FormControl>
    )

}


export default RadioButtonForm;
